import type { MultiSelection } from '../../selection.js';

export const RANGE_HANDLE_ACTIVATION_DISTANCE = 8;

function getIndexAtPointer(positions: number[], pointer: number): number {
  const lastCellIndex = positions.length - 2;
  if (lastCellIndex < 0) return 0;
  const index = positions.slice(1).findIndex(boundary => pointer < boundary);
  return Math.max(
    0,
    Math.min(lastCellIndex, index < 0 ? lastCellIndex : index)
  );
}

export function getRangeHandleSelection({
  columns,
  currentColumns,
  currentRows,
  deltaX,
  deltaY,
  pointerX,
  pointerY,
  rows,
}: {
  columns: number[];
  currentColumns: MultiSelection;
  currentRows: MultiSelection;
  deltaX: number;
  deltaY: number;
  pointerX: number;
  pointerY: number;
  rows: number[];
}): { column: MultiSelection; row: MultiSelection } | undefined {
  if (rows.length < 2 || columns.length < 2) return;

  // The handle lives exactly on the shared bottom/right grid boundary. Keep
  // each axis inside the current last cell until the pointer has deliberately
  // moved eight pixels on that axis; merely grabbing the handle must not add
  // the neighbouring row or column.
  const effectiveX =
    Math.abs(deltaX) < RANGE_HANDLE_ACTIVATION_DISTANCE
      ? (columns[currentColumns.end + 1] ?? columns.at(-1)!) - 0.5
      : pointerX;
  const effectiveY =
    Math.abs(deltaY) < RANGE_HANDLE_ACTIVATION_DISTANCE
      ? (rows[currentRows.end + 1] ?? rows.at(-1)!) - 0.5
      : pointerY;
  const targetColumn = getIndexAtPointer(columns, effectiveX);
  const targetRow = getIndexAtPointer(rows, effectiveY);

  return {
    column: {
      start: Math.min(currentColumns.start, targetColumn),
      end: Math.max(currentColumns.end, targetColumn),
    },
    row: {
      start: Math.min(currentRows.start, targetRow),
      end: Math.max(currentRows.end, targetRow),
    },
  };
}
